module.exports = __webpack_public_path__ + "img/img41.e614932e.svg";